import { DataType, TranslationUploadForm } from './types'

export const EMPTY_UPLOAD_FORM: TranslationUploadForm = {
  stepOne: {
    dataType: 'files',
    templates: [],
    files: [],
  },
  stepTwo: {
    dataType: 'files',
    templates: [],
    files: [],
  },
}

export const LABELS_BY_DATA_TYPE: Record<DataType, string> = {
  files: 'Files uploaded',
  templates: 'Templates selected',
}

export const FILE_VALIDATION_ERROR = {
  COUNT: 'At least one file is required',
  MAX_COUNT: 'Only two files are allowed',
  EMPTY_OBJECTIVE: 'Please select file type',
  DATA_DICTIONARY_REQUIRED: 'Data dictionary file is required',
  SAME_OBJECTIVE: 'Files should have different file types',
} as const
